import { render, staticRenderFns } from "./PanelRight.vue?vue&type=template&id=4fcc6725&"
import script from "./PanelRight.vue?vue&type=script&lang=js&"
export * from "./PanelRight.vue?vue&type=script&lang=js&"
import style0 from "./PanelRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports